import { ISlot } from '../../../uanc.types';
import { AD_SERVERS, SMART_LL } from '../../../configs/constants';
import { IDFPServiceSlot } from './service-dfp.types';
import { ILazyLoadingSetting } from '../ad-services.types';

/**
 * Zwraca konfigurację lazy loading na podstawie parametrów dla wersji mobile i desktop.
 *
 * @param {boolean} isMobile - informacja o trybie urządzenia
 * @param {boolean} isLazyLoading - ustawienia lazy loading slotu
 * @param {boolean} isLazyLoadingMobile - ustawienia lazy loading mobile slotu
 * @param {boolean} lazyLoadingPosition - ustawienia odległości lazy loading
 * @param {boolean} lazyLoadingPositionMobile - ustawienia odległości lazy loading dla mobile
 * @returns {ILazyLoadingSetting} ustawienia lazy loadingu
 */
const getLazyLoadingSetting = (
    isMobile: boolean,
    isLazyLoading: boolean | null,
    isLazyLoadingMobile: boolean | null,
    lazyLoadingPosition: number | null,
    lazyLoadingPositionMobile: number | null
): ILazyLoadingSetting => {
    return {
        isLazyLoading: isMobile && isLazyLoadingMobile != null ? isLazyLoadingMobile : (isLazyLoading ?? false),
        lazyLoadingPosition: isMobile && lazyLoadingPositionMobile != null ? lazyLoadingPositionMobile : (lazyLoadingPosition ?? 300),
    };
};

/**
 * Przygotowuje obiekt konfiguracji slotu DFP na podstawie obiektu otrzymanego z ADC. Uzupełnia brakujące pola, waliduje.
 *
 * @param {ISlot} slot - slot
 * @returns {IDFPServiceSlot} pełna konfiguracja slotu
 */
export const prepareSlotDfp = (slot: ISlot): IDFPServiceSlot => {
    const { detection, config } = window.Inpl.Ad;

    const lazyLoadingSettings = getLazyLoadingSetting(
        detection!.isMobile,
        slot.isLazyLoading,
        slot.isLazyLoadingMobile ?? null,
        slot.lazyLoadingPosition,
        slot.lazyLoadingPositionMobile ?? null
    );

    const commonFields = {
        name: slot.name,
        isTest: slot.isTest ?? false,
        adServer: AD_SERVERS.DFP,
        disable: slot.disable ?? false,
        bidders: slot.bidders || [],
        keywords: slot.keywords || [],
        mapping: slot.mapping || [],
        outOfPage: slot.outOfPage,
        prebid: slot.prebid,
        sizes: slot.sizes ?? [],
        slotid: slot.slotid ? slot.slotid : `dfp_${slot.name}`,
        ...lazyLoadingSettings,
    };

    const serviceSlotConfig: IDFPServiceSlot = {
        ...commonFields,
        renderedPlacements: null,
        path: null,
        placementIds: [`ad-${slot.name}`],
        loadingTime: Date.now(),
        refreshed: 0,
    };

    if (config?.adPath && SMART_LL[config.adPath]?.[slot.name]) {
        serviceSlotConfig.isLazyLoading = false;
        serviceSlotConfig.placementIds = [`ad-${slot.name}`];
        serviceSlotConfig.smartIsLazyLoading = typeof slot.isLazyLoading === 'boolean' ? slot.isLazyLoading : false;
        serviceSlotConfig.smartLL = true;
        serviceSlotConfig.smartLLName = `${slot.name}_${SMART_LL[config.adPath][slot.name]}`;
    }
    return serviceSlotConfig;
};
